module.exports = __webpack_public_path__ + "img/H000130_applegreen.e3439d1d.png";